import { set, pick } from 'lodash'
import { FORMAT_TYPES } from '@wix/wix-data-client-common'
import { BINDING_TYPES } from '../../business-logic/bindings/Binding'
import * as connectionConfigHelper from '../../business-logic/connections/connectionConfigHelper'

const createDatetimeFormatConfig = dateFormat => ({
  format: connectionConfigHelper.createFormat({
    formatType: FORMAT_TYPES.DATETIME,
    dateFormat,
  }),
})

export const createConnectionConfig = (bindings = []) => {
  const connectionConfig = bindings.reduce((config, binding) => {
    switch (binding.type) {
      case BINDING_TYPES.Field: {
        const { prop, fieldPath, format, linkTarget, linkRel } = binding
        const bindingConfig = {
          fieldName: fieldPath,
          ...(format && createDatetimeFormatConfig(format)),
          ...(linkTarget && { linkTarget }),
          ...(linkRel !== undefined // There can be an empty string.
            ? { linkRel }
            : null),
        }
        set(config, ['properties', prop], bindingConfig)
        return config
      }

      case BINDING_TYPES.Expression: {
        const { prop, expression } = binding
        set(config, ['expressions', prop], { expression })
        return config
      }

      case BINDING_TYPES.TotalCount: {
        const { prop } = binding
        set(config, 'totalCount', { prop })
        return config
      }

      case BINDING_TYPES.Action: {
        const { event, action, postAction } = binding
        set(config, `events.${event}.action`, action)
        if (postAction) {
          set(
            config,
            `events.${event}.postAction`,
            pick(postAction, 'navigate'),
          )
        }
        return config
      }

      case BINDING_TYPES.Behavior: {
        const { behavior } = binding
        set(config, 'behaviors', [{ type: behavior }])
        return config
      }

      case BINDING_TYPES.Filter: {
        const { prop, fieldPath, condition } = binding
        set(config, 'userInputFilter', {
          fieldName: fieldPath,
          prop,
          condition,
        })
        return config
      }

      default:
        return config
    }
  }, {})
  return Object.keys(connectionConfig).length ? connectionConfig : undefined
}

export const disconnectBinding = ({
  editorSdkProxy,
  controllerRef,
  componentRef,
  role,
}) =>
  editorSdkProxy.controllers.disconnect({
    controllerRef,
    role,
    connectToRef: componentRef,
  })
